var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.92 3.09205L2.7471 8.79416C1.77986 9.19948 1.78545 9.76244 2.56964 10.0135L6.2084 11.1978L14.6274 5.65579C15.0255 5.40309 15.3892 5.53903 15.0903 5.81592L8.26919 12.2386H8.26759L8.26919 12.2394L8.01818 16.1526C8.38589 16.1526 8.54817 15.9766 8.75441 15.769L10.5218 13.9758L14.1982 16.809C14.876 17.1984 15.3628 16.9983 15.5315 16.1543L17.9448 4.28802C18.1918 3.25468 17.5667 2.78681 16.92 3.09205Z","fill":"#004EFF"}));
}

Telegram.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
